// extracted by mini-css-extract-plugin
export default {"productList":"ProductList_productList__6p2Fu"};